module.exports = __webpack_public_path__ + "img/camera.318806cb.svg";